var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 72,
    viewBox: "0 0 79 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1154_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 63C57.1355 63 69 51.1355 69 36.5C69 21.8645 57.1355 10 42.5 10C27.8645 10 16 21.8645 16 36.5C16 51.1355 27.8645 63 42.5 63Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 62.75C56.9975 62.75 68.75 50.9975 68.75 36.5C68.75 22.0025 56.9975 10.25 42.5 10.25C28.0025 10.25 16.25 22.0025 16.25 36.5C16.25 50.9975 28.0025 62.75 42.5 62.75Z",
    stroke: "#343434",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1154_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 23,
    width: 29,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 48L28.2813 23H56.9286V48H28.2812Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1154_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9778 23.2614L28.597 36.6418C28.5135 36.7257 28.4492 36.8221 28.4036 36.9312C28.3584 37.0407 28.3359 37.1544 28.3359 37.2725V47.0851C28.3359 47.1731 28.3487 47.2595 28.3743 47.3441C28.3998 47.4284 28.4371 47.5071 28.4862 47.5807C28.5352 47.6539 28.5936 47.7185 28.662 47.7745C28.73 47.8304 28.805 47.8753 28.8865 47.9092C28.968 47.943 29.0526 47.9641 29.1403 47.9727C29.2281 47.9813 29.3154 47.9772 29.4018 47.9599C29.4885 47.9427 29.5703 47.9133 29.6484 47.8715C29.7261 47.8301 29.7962 47.7783 29.8584 47.7157L42.6084 34.966L55.3585 47.7157C55.4206 47.7783 55.4908 47.8301 55.5685 47.8715C55.6465 47.9133 55.7284 47.9427 55.8151 47.9599C55.9014 47.9772 55.9888 47.9813 56.0765 47.9727C56.1643 47.9641 56.2489 47.943 56.3304 47.9092C56.4119 47.8753 56.4868 47.8304 56.5549 47.7745C56.6233 47.7185 56.6816 47.6539 56.7307 47.5807C56.7797 47.5071 56.817 47.4284 56.8426 47.3441C56.8681 47.2595 56.8809 47.1731 56.8809 47.0851V37.2725C56.8809 37.1544 56.8585 37.0407 56.8132 36.9312C56.7676 36.8221 56.7034 36.7257 56.6198 36.6418L43.2391 23.2614C43.1976 23.22 43.1527 23.183 43.104 23.1506C43.0553 23.1178 43.0039 23.0905 42.9497 23.068C42.8958 23.0456 42.8398 23.0287 42.7825 23.0173C42.7252 23.0059 42.6671 23 42.6084 23C42.5497 23 42.4917 23.0059 42.4344 23.0173C42.377 23.0287 42.3211 23.0456 42.2672 23.068C42.213 23.0905 42.1615 23.1178 42.1128 23.1506C42.0641 23.183 42.0192 23.22 41.9778 23.2614ZM55.097 37.642V44.9316L43.2391 33.0737C43.1976 33.0322 43.1527 32.9953 43.104 32.9628C43.0553 32.9304 43.0039 32.9027 42.9497 32.8803C42.8958 32.8578 42.8398 32.8409 42.7825 32.8295C42.7248 32.8181 42.6671 32.8126 42.6084 32.8126C42.5497 32.8126 42.4917 32.8181 42.4344 32.8295C42.377 32.8409 42.3211 32.8578 42.2672 32.8803C42.213 32.9027 42.1615 32.9304 42.1128 32.9628C42.0641 32.9953 42.0192 33.0322 41.9778 33.0737L30.1198 44.9316V37.642L42.6084 25.1534L55.097 37.642Z",
    fill: "#0075FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1154_2",
    x: 0.9,
    y: 0.9,
    width: 83.2,
    height: 83.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1154_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1154_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopScroll);
export default __webpack_public_path__ + "static/media/topScroll.9bec7e9167c402e78a496775efe775ee.svg";
export { ForwardRef as ReactComponent };